module.exports = __webpack_public_path__ + "static/maize-d0b9744f7770fa7a99bc5260de371abf.jpg";